/*
This file is for handle Speaker.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 07/12/2017 12:05 PM
*/
/* global document */

import Element from './../Element';
import View from './../View';
import DefaultSkin from '../assets/css/defaultCss';
/*
 * Speaker represents the volume icon that will be shown in the mediaPlayer, for example.
 * It manages the volume level of the media tag given in the constructor.
 * Every Speaker is a View.
 * Ex.: var speaker = Speaker({elementID: element, media: mediaTag, id: id});
 */
const Speaker = (spec) => {
    const that = View({});
    let lastVolume = 50;
    const isDefaultSkin = spec.skin === 'default';
    const mute = () => {
        that.media.muted = true;
        that.div.classList.remove('fa-volume-up');
        that.div.classList.add('fa-volume-off');
        if (that.stream.local) {
            that.stream.stream.getAudioTracks()[0].enabled = false;
        } else {
            lastVolume = that.picker.value;
            that.picker.value = 0;
            that.media.volume = 0;
        }
    };
    const unmute = () => {
        that.media.muted = false;
        that.div.classList.remove('fa-volume-off');
        that.div.classList.add('fa-volume-up');
        //that.div.setAttribute('src', `${that.url}/assets/sound48.png`);
        if (that.stream.local) {
            that.stream.stream.getAudioTracks()[0].enabled = true;
        } else {
            that.picker.value = lastVolume;
            that.media.volume = that.picker.value / 100;
        }
    };

    // Variables
    // DOM element in which the Speaker will be appended
    that.elementID = spec.elementID;

    // media tag
    that.media = spec.media;

    // Speaker id
    that.id = spec.id;

    // MediaStream
    that.stream = spec.stream;

    const spkr_pos = spec.position;
    // Container
    if (isDefaultSkin) {
        that.div = Element({
            name: 'i',
            class: 'fa fa-volume-up fa-fw fa-lg',
            style: Object.assign(DefaultSkin.icon, DefaultSkin.icon_volume),
            id: `volume_${that.id}`,
        });
    } else {
        that.div = Element({
            name: 'i',
            class: `fa fa-volume-up fa-fw fa-lg ${spec.skin}_icon ${spec.skin}_icon_volume`,
            id: `volume_${that.id}`,
        });
    }
    Element.setStyle(that.div, spec.position, '0');


    that.div.onclick = () => {
        if (that.media.muted) {
            unmute();
        } else {
            mute();
        }
    };

    if (!that.stream.local) {
        // Volume bar
        that.picker = document.createElement('input');
        that.picker.setAttribute('id', `picker_${that.id}`);
        that.picker.setAttribute('style', 'position: absolute;max-width: 50px;margin: 1.1%;top:0;');
        that.picker.type = 'range';
        that.picker.min = 0;
        that.picker.max = 1;
        that.picker.step = 0.1;
        that.picker.value = lastVolume;
        //  FireFox supports range sliders as of version 23
        that.picker.setAttribute('orient', 'vertical');
        that.div.appendChild(that.picker);
        that.media.volume = that.picker.value;
        that.media.muted = false;

        that.picker.onclick = () => {
            if (that.picker.value > 0) {
                that.media.muted = false;
                that.div.classList.remove('fa-volume-off');
                that.div.classList.add('fa-volume-up');
            } else {
                that.media.muted = true;
                that.div.classList.remove('fa-volume-up');
                that.div.classList.add('fa-volume-off');
            }
            that.media.volume = that.picker.value;
        };


        // Private functions
        const show = (displaying) => {
            that.picker.setAttribute('style', `position: absolute;max-width: 50px;margin: 1.1%;margin-left:32px;top:0;display: ${displaying}`);
        };

        //	Element.setStyle(that.picker,spec.position,`${that.div.offsetHeight}px`);
        // Public functions
        that.div.onmouseover = () => {
            show('block');
        };


        that.picker.onmouseout = () => {
            show('none');
        };
        show('none');
    }

    document.getElementById(that.elementID).appendChild(that.div);
    return that;
};

export default Speaker;



//////////////////
// WEBPACK FOOTER
// ./src/views/component/Speaker.js
// module id = 181
// module chunks = 0